import { IonList, IonText } from '@ionic/react';
import type { GetFantasyLeagueMatchWeekScoresQuery } from '../../../../types/graphql-generated';
import { withAvatarCacheBuster } from '../../../../lib/avatarUrl';
import { FantasyLeagueMember } from './FantasyLeagueMember';

type Lineup =
  NonNullable<GetFantasyLeagueMatchWeekScoresQuery['fantasyLeagueMatchWeekScores']>['lineups'][number];

interface ResultsSegmentProps {
  lineups: Lineup[];
  leadingMemberId: string | null;
  lastMemberId: string | null;
  onLineupClick: (fantasyLeagueMemberId: string) => void;
}

export const ResultsSegment = ({
  lineups,
  leadingMemberId,
  lastMemberId,
  onLineupClick,
}: ResultsSegmentProps) => {
  if (lineups.length === 0) {
    return (
      <IonText color="medium">
        <p className="ion-padding">No están disponibles los resultados para esta jornada</p>
      </IonText>
    );
  }

  return (
    <IonList>
      {lineups.map((lineup, index) => (
        <FantasyLeagueMember
          key={lineup.id}
          position={index + 1}
          teamName={lineup.fantasyLeagueMember.teamName || 'Usuario desconocido'}
          score={lineup.totalScore}
          userPicture={withAvatarCacheBuster(
            lineup.fantasyLeagueMember.user.picture,
            lineup.fantasyLeagueMember.user.updatedAt
          )}
          userName={lineup.fantasyLeagueMember.user.fullName ?? undefined}
          isLeader={lineup.fantasyLeagueMember.id === leadingMemberId}
          isLast={lineup.fantasyLeagueMember.id === lastMemberId}
          onClick={() => onLineupClick(lineup.fantasyLeagueMember.id)}
        />
      ))}
    </IonList>
  );
};
